<div *ngIf="isFlagView" class="date-flagged-block">
  <div class="cg-font-size-xs">
    {{ 'dashboard.dateFlagged' | translate }} {{ patient.dateFlagged }}
  </div>
</div>
<div *ngIf="!isFlagView" class="date-flagged-block">
  <div class="cg-font-size-xs">
    {{ 'dashboard.eligibilityAsOfDate' | translate }}
    {{ formatQueryParams(patient.asOfDate).asof | date: 'MM/d/yyyy' }}
  </div>
</div>
<div class="cg-flex-vertical-center">
  <div class="flag-block">
    <cigna-flag
      data-test="flagicon"
      [disabled]="!isEditable"
      size="medium"
      [flagged]="flaggedKeys.includes(patient.coverage.compositeKey)"
      (change)="flagClick($event, patient)"
    ></cigna-flag>
  </div>
  <div class="name-block divider-right">
    <div class="cg-margin-bottom-sm">
      <a
        *ngIf="!patient.coverage.isInactive && !isRestrictedImpersonator"
        class="cg-font-size-m"
        data-test="patientplandetail"
        [routerLink]="[
          '/patient/detail/',
          patient.coverage.compositeKey,
          parseCoverageType(patient.coverage.coverageType)
        ]"
        [queryParams]="formatQueryParams(patient.asOfDate)"
        [cignaTrackClicks]="[
          'trackEventOther',
          'Patients',
          'ac-DB004-Patient Click',
          {
            prop20: isFlagView ? 'Flagged' : 'Recent',
            events: isFlagView ? 'event434' : 'event433'
          }
        ]"
      >
        <strong data-test="patientName">
          {{ patient.firstName }} {{ patient.lastName }}</strong
        >
      </a>
      <strong *ngIf="patient.coverage.isInactive || isRestrictedImpersonator"
        >{{ patient.firstName }} {{ patient.lastName }}</strong
      >
    </div>

    <cigna-coverage-status
      size="small"
      [inactive]="patient.coverage.isInactive"
      [status]="patient.coverage.coverageStatus"
    ></cigna-coverage-status>
  </div>

  <div class="detail-block">
    <div class="cg-margin-right-sm">
      <div class="secondary-text cg-font-size-xs">
        {{ 'dashboard.dashboardComponent.dob' | translate }}
      </div>
      <div data-test="patientDob">{{ patient.dob | date: 'MM/d/yyyy' }}</div>
    </div>

    <div>
      <div class="secondary-text cg-font-size-xs">
        {{ 'dashboard.dashboardComponent.patientId' | translate }}
      </div>
      <div data-test="patientId">
        {{
          !isRestrictedImpersonator
            ? patient.patientId || patient.ami || '--'
            : '--'
        }}
      </div>
    </div>
  </div>
</div>
